import { FaTrash } from "react-icons/fa";

export default function FAQSection({
  formData,
  handleAddFAQ,
  handleDeleteFAQ,
  handleInputChange,
}) {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold mb-4">FAQs</h2>

      {formData.FAQs.map((faq, i) => (
        <div
          key={i}
          className="mb-4 border p-4 rounded relative bg-white"
        >
          {/* Delete Icon */}
          {formData.FAQs.length > 1 && (
            <button
              type="button"
              onClick={() => handleDeleteFAQ(i)}
              className="
                absolute top-1 right-1
                flex items-center justify-center
                w-9 h-9
                rounded-full
                text-gray-400
                hover:text-gray-600
                hover:bg-gray-100
                focus:outline-none focus:ring-2 focus:ring-gray-300
              "
              aria-label="Delete FAQ"
            >
              <FaTrash size={14} />
            </button>
          )}

          <label className="block text-sm font-medium mb-1">
            Question
          </label>
          <input
            name="Q"
            value={faq.Q}
            onChange={(e) => handleInputChange(e, i, "FAQs")}
            placeholder="Enter question"
            className="border p-2 w-full mb-3 rounded"
          />

          <label className="block text-sm font-medium mb-1">
            Answer
          </label>
          <input
            name="A"
            value={faq.A}
            onChange={(e) => handleInputChange(e, i, "FAQs")}
            placeholder="Enter answer"
            className="border p-2 w-full rounded"
          />
        </div>
      ))}

      <button
        type="button"
        onClick={handleAddFAQ}
        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
      >
        Add FAQ
      </button>
    </div>
  );
}
